import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
function Footertwo() {
  const navigate  = useNavigate();
  return (
    <><footer className='landing'>

      <div className="container-fluid">

        <Row className='desktop-footer'>
          <Col>

            <p>Copyright © 2025 XCUTTA. All Rights Reserved.</p>
          </Col>
          <Col className='d-flex justify-content-end'>

            <p style={{cursor: 'pointer'}}><a onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</a></p>
          </Col>

        </Row>
        <Row className='mob-footer'>
          <Col md="12">

            <p>Copyright © 2025 XCUTTA. All Rights Reserved.</p>
          </Col>
          <Col md="12">

            <p><a onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</a></p>
          </Col>

        </Row>
      </div>
    </footer></>
  );
}

export default Footertwo;